
//dashboard
export const dashboardDistanceRoute = "/dashboard/dystans";
export const dashboardFuelConsuptionRoute = "/dashboard/spalanie";
export const dashboardFuelEcoRoute = "/dashboard/trasy_eco";
export const dashboardDriveTimeRoute = "/dashboard/czas_jazdy";
export const dashboardPrivateTimeRoute = "/dashboard/czas_prywatny";
export const dashboardInServiceListRoute = "/dashboard/lista_serwis";
export const dashboardEcoGradeRoute = "/dashboard/ocena_eco";
export const dashboardEcoListRoute = "/dashboard/lista_eco";
export const dashboardAlertListRoute = "/dashboard/lista_alerty";
export const dashboarTrophyListRoute = "/dashboard/lista_trofea";


//auth
export const authLogInRoute = "/logowanie";
export const authForgotPasswordRoute = "/reset_hasla";

//map
export const mapCarListRoute = "/mapa/lista_aut";
export const mapRoutesListRoute = "/mapa/lista_tras";
export const mapCurrentRouteRoute = "/mapa/biezaca_trasa";

//cars
export const carsListRoute = "/samochody/lista_aut";
export const carsRentListRoute = "/samochody/lista_najmow";
export const carsRentRoute = "/samochody/wynajem";
export const carsPoolRoute = "/samochody/pool";
export const carsZoneRoute = "/samochody/rejon";
export const carsZonePoolRoute = "/samochody/rejon_pool";
export const carsWorkingHoursRoute = "/samochody/godziny_pracy";
export const carsInsuranceRoute = "/samochody/ubezpieczenie";
export const carsTechnicalInspectionRoute = "/samochody/przeglad_techniczny";
export const carsGroupDeleteRoute = "/samochody/grupy";
export const carsServiceInspectionRoute = "/samochody/przeglad_serwisowy";
export const carsServiceInspectionsRoute = "/samochody/przeglad_serwisowy/lista";
export const carsServiceInspectionsResetRoute = "/samochody/przeglad_serwisowy/reset";
export const carsContractedMileageRoute = "/samochody/kontraktowanie_przebiegu";
export const carsDataRoute = "/samochody/dane";
export const carsReportsRoute = "/samochody/raporty";
export const carsSettingsRoute = "/samochody/ustawienia";
export const carsParametersRoute = "/samochody/parametry";
export const carsEvidenceRoute = "/samochody/ewidencja";
export const carsParametersListRoute = "/samochody/lista_parametry";
export const carsSmsRoute = "/samochody/sms";
export const carsEcoChartRoute = "/samochody/wykres_eco";
export const carsChangesRoute = "/samochody/zmiany";
export const carsRemarksRoute = "/samochody/uwagi";
export const carsDamage = "/samochody/uszkodzenia";
export const carsDamageImageUrl = "/samochody/uszkodzenia/obraz";
export const carsPricing = "/samochody/cennik";

//groups
export const groupsListRoute = "/grupy/lista_grup";
export const groupsCarsListRoute = "/grupy/lista_aut";

//reports
export const reportsListRoute = "/raporty/lista_raporty";
export const reportsPendingReportsRoute = "/raporty/oczekujace_raporty";
export const reportsAutomaticReportsRoute = "/raporty/lista_raporty_automatyczne";
export const settingsAddFile = "/raporty/dodaj_plik";
//drivers
export const driversListRoute = "/kierowcy/lista_kierowcy";
export const driversImportRoute = "/kierowcy/import_kierowcy";
export const driversEcoChart = "/kierowcy/wykres_eco";
export const driversResetMobileAppKeyRoute = "/kierowcy/resetuj_klucz_mobilny";

//users
export const usersListRoute = "/uzytkownicy/lista_uzytkownicy";
export const usersCarsListRoute = "/uzytkownicy/lista_aut";
export const usersPasswordResetRoute = "/uzytkownicy/reset_hasla";
export const usersPasswordExpirationRoute = "/uzytkownicy/waznosc_hasla";

//settings
export const settingsContactDataRoute = "/ustawienia/dane_kontaktowe";
export const settingsNotificationsRoute = "/ustawienia/powiadomienia";
export const settingsRemindersRoute = "/ustawienia/przypomnienia";
export const settingsOthersRoute = "/ustawienia/inne_ustawienia";
export const settingsTrophyRoute = "/ustawienia/trofea";
export const settingsChangePasswordRoute = "/ustawienia/haslo";
export const settingsUsernameChangeRoute = "/ustawienia/nazwa_uzytkownika";
export const settingsMobileAppKeyRoute = "/ustawienia/mobilne";
export const settingsTiresChangeRoute = "/ustawienia/wymiana_opon";
export const settingsRegularHolidaysRoute = "/ustawienia/swieta_regularne";
export const settingsMovingHolidaysRoute = "/ustawienia/swieta_ruchome";
export const settingsDaysOffRoute = "/ustawienia/dni_wolne";
export const settingsImportDaysOffRoute = "/ustawienia/import_dni_wolne";
export const settingsWorkingHoursRoute = "/ustawienia/godziny_pracy";
export const settingsPoiPointsRoute = "/ustawienia/punkty_poi";
export const settingsImportPoiPointsRoute = "/ustawienia/import_poi";
export const setingsDeleteAllPoi = "/ustawienia/usun_poi";
export const settingsExpectedCombustion ="/ustawienia/oczekiwane_spalanie";


//rent
export const rentSettingsRoute = "/wynajmy/ustawienia";
export const rentOperatorsRoute = "/wynajmy/operatorzy";
export const rentOperatorsPasswordExpirationRoute = "/wynajmy/operatorzy/waznosc_hasla";
export const rentOperatorsPasswordResetRoute ="/wynajmy/operatorzy/reset_hasla";
export const rentPricingRoute = "/wynajmy/cenniki";
export const rentClientRoute = "/wynajmy/klienci";
export const rentClientImportRoute ="/wynajmy/import_klienci";

//common
export const commonReadAddressRoute = "/wspolne/odczytaj_adres";
export const commonReadGpsCoordsRoute = "/wspolne/odczytaj_punktgps";
export const commonNotificationsRoute = "/wspolne/powiadomienia";
export const commonFiltersRoute = "/wspolne/filtry";
export const commonReadLocationRoute = "/wspolne/odczytaj_punktgps";

//utility
export const rodoAcceptRoute = "/rodo";
export const forcePasswordRoute="/ustawienia/wymus_haslo";
